module.exports = __webpack_public_path__ + "09839e2cd707999b472d6631640dba1c.svg";